"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _router = _interopRequireDefault(require("@/router"));
var _underLoading = require("../helpers/under-loading");
var _helpers = require("@/helpers");
var _customField = _interopRequireDefault(require("@/services/customField.service"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
var state = {};
var mutations = {};
var getters = {};
var actions = {
  getCustomFields: (0, _underLoading.underLoadingFunction)(/*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(_ref, params) {
      var commit, _yield$CustomFieldSer, data, _t;
      return _regenerator().w(function (_context) {
        while (1) switch (_context.p = _context.n) {
          case 0:
            commit = _ref.commit;
            _context.p = 1;
            _context.n = 2;
            return _customField.default.fetchAll(params);
          case 2:
            _yield$CustomFieldSer = _context.v;
            data = _yield$CustomFieldSer.data;
            return _context.a(2, data);
          case 3:
            _context.p = 3;
            _t = _context.v;
            _helpers.errorResponseHelper.display(_t);
            return _context.a(2, false);
        }
      }, _callee, null, [[1, 3]]);
    }));
    return function (_x, _x2) {
      return _ref2.apply(this, arguments);
    };
  }()),
  getCustomFieldItem: (0, _underLoading.underLoadingFunction)(/*#__PURE__*/function () {
    var _ref4 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(_ref3, id) {
      var commit, _yield$CustomFieldSer2, data, _t2;
      return _regenerator().w(function (_context2) {
        while (1) switch (_context2.p = _context2.n) {
          case 0:
            commit = _ref3.commit;
            _context2.p = 1;
            _context2.n = 2;
            return _customField.default.fetchItem(id);
          case 2:
            _yield$CustomFieldSer2 = _context2.v;
            data = _yield$CustomFieldSer2.data;
            return _context2.a(2, data);
          case 3:
            _context2.p = 3;
            _t2 = _context2.v;
            _helpers.errorResponseHelper.display(_t2);
            return _context2.a(2, false);
        }
      }, _callee2, null, [[1, 3]]);
    }));
    return function (_x3, _x4) {
      return _ref4.apply(this, arguments);
    };
  }()),
  editCustomField: (0, _underLoading.underLoadingFunction)(/*#__PURE__*/function () {
    var _ref7 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(_ref5, _ref6) {
      var commit, payload, id, _yield$CustomFieldSer3, data, successMessage, _t3;
      return _regenerator().w(function (_context3) {
        while (1) switch (_context3.p = _context3.n) {
          case 0:
            commit = _ref5.commit;
            payload = _ref6.payload, id = _ref6.id;
            _context3.p = 1;
            _context3.n = 2;
            return _customField.default.update(payload, id);
          case 2:
            _yield$CustomFieldSer3 = _context3.v;
            data = _yield$CustomFieldSer3.data;
            successMessage = _router.default.app.$t('pages.type_services.msgs.update_success');
            _helpers.messageHelper.success(successMessage);
            return _context3.a(2, data);
          case 3:
            _context3.p = 3;
            _t3 = _context3.v;
            _helpers.errorResponseHelper.display(_t3);
            return _context3.a(2, false);
        }
      }, _callee3, null, [[1, 3]]);
    }));
    return function (_x5, _x6) {
      return _ref7.apply(this, arguments);
    };
  }()),
  createCustomField: (0, _underLoading.underLoadingFunction)(/*#__PURE__*/function () {
    var _ref0 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4(_ref8, _ref9) {
      var commit, payload, _yield$CustomFieldSer4, data, successMessage, _t4;
      return _regenerator().w(function (_context4) {
        while (1) switch (_context4.p = _context4.n) {
          case 0:
            commit = _ref8.commit;
            payload = _ref9.payload;
            _context4.p = 1;
            _context4.n = 2;
            return _customField.default.create(payload);
          case 2:
            _yield$CustomFieldSer4 = _context4.v;
            data = _yield$CustomFieldSer4.data;
            successMessage = _router.default.app.$t('pages.type_services.msgs.create_success');
            _helpers.messageHelper.success(successMessage);
            return _context4.a(2, data);
          case 3:
            _context4.p = 3;
            _t4 = _context4.v;
            _helpers.errorResponseHelper.display(_t4);
            return _context4.a(2, false);
        }
      }, _callee4, null, [[1, 3]]);
    }));
    return function (_x7, _x8) {
      return _ref0.apply(this, arguments);
    };
  }()),
  getLinkedCustomFields: (0, _underLoading.underLoadingFunction)(/*#__PURE__*/function () {
    var _ref10 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5(_ref1, params) {
      var commit, _yield$CustomFieldSer5, data, _t5;
      return _regenerator().w(function (_context5) {
        while (1) switch (_context5.p = _context5.n) {
          case 0:
            commit = _ref1.commit;
            _context5.p = 1;
            _context5.n = 2;
            return _customField.default.fetchLinkedServices(params);
          case 2:
            _yield$CustomFieldSer5 = _context5.v;
            data = _yield$CustomFieldSer5.data;
            return _context5.a(2, data);
          case 3:
            _context5.p = 3;
            _t5 = _context5.v;
            _helpers.errorResponseHelper.display(_t5);
            return _context5.a(2, false);
        }
      }, _callee5, null, [[1, 3]]);
    }));
    return function (_x9, _x0) {
      return _ref10.apply(this, arguments);
    };
  }()),
  execUnlinkCustomField: (0, _underLoading.underLoadingFunction)(/*#__PURE__*/function () {
    var _ref12 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6(_ref11, params) {
      var commit, _yield$CustomFieldSer6, data, successMessage, _t6;
      return _regenerator().w(function (_context6) {
        while (1) switch (_context6.p = _context6.n) {
          case 0:
            commit = _ref11.commit;
            _context6.p = 1;
            _context6.n = 2;
            return _customField.default.unlinkCustomField(params);
          case 2:
            _yield$CustomFieldSer6 = _context6.v;
            data = _yield$CustomFieldSer6.data;
            successMessage = _router.default.app.$t('pages.type_services.msgs.update_success');
            _helpers.messageHelper.success(successMessage);
            return _context6.a(2, data);
          case 3:
            _context6.p = 3;
            _t6 = _context6.v;
            _helpers.errorResponseHelper.display(_t6);
            return _context6.a(2, false);
        }
      }, _callee6, null, [[1, 3]]);
    }));
    return function (_x1, _x10) {
      return _ref12.apply(this, arguments);
    };
  }()),
  execLinkCustomFields: (0, _underLoading.underLoadingFunction)(/*#__PURE__*/function () {
    var _ref14 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7(_ref13, payload) {
      var commit, _yield$CustomFieldSer7, data, successMessage, _t7;
      return _regenerator().w(function (_context7) {
        while (1) switch (_context7.p = _context7.n) {
          case 0:
            commit = _ref13.commit;
            _context7.p = 1;
            _context7.n = 2;
            return _customField.default.linkCustomFields(payload);
          case 2:
            _yield$CustomFieldSer7 = _context7.v;
            data = _yield$CustomFieldSer7.data;
            successMessage = _router.default.app.$t('pages.type_services.msgs.update_success');
            _helpers.messageHelper.success(successMessage);
            return _context7.a(2, data);
          case 3:
            _context7.p = 3;
            _t7 = _context7.v;
            _helpers.errorResponseHelper.display(_t7);
            return _context7.a(2, false);
        }
      }, _callee7, null, [[1, 3]]);
    }));
    return function (_x11, _x12) {
      return _ref14.apply(this, arguments);
    };
  }()),
  deleteCustomField: (0, _underLoading.underLoadingFunction)(/*#__PURE__*/function () {
    var _ref16 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee8(_ref15, params) {
      var commit, _t8;
      return _regenerator().w(function (_context8) {
        while (1) switch (_context8.p = _context8.n) {
          case 0:
            commit = _ref15.commit;
            _context8.p = 1;
            _context8.n = 2;
            return _customField.default.deleteCustomField(params);
          case 2:
            return _context8.a(2, true);
          case 3:
            _context8.p = 3;
            _t8 = _context8.v;
            _helpers.errorResponseHelper.display(_t8);
            return _context8.a(2, false);
        }
      }, _callee8, null, [[1, 3]]);
    }));
    return function (_x13, _x14) {
      return _ref16.apply(this, arguments);
    };
  }()),
  deleteOptionCustomField: (0, _underLoading.underLoadingFunction)(/*#__PURE__*/function () {
    var _ref18 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee9(_ref17, params) {
      var commit, _t9;
      return _regenerator().w(function (_context9) {
        while (1) switch (_context9.p = _context9.n) {
          case 0:
            commit = _ref17.commit;
            _context9.p = 1;
            _context9.n = 2;
            return _customField.default.deleteOptionCustomField(params);
          case 2:
            return _context9.a(2, true);
          case 3:
            _context9.p = 3;
            _t9 = _context9.v;
            _helpers.errorResponseHelper.display(_t9);
            return _context9.a(2, false);
        }
      }, _callee9, null, [[1, 3]]);
    }));
    return function (_x15, _x16) {
      return _ref18.apply(this, arguments);
    };
  }())
};
var _default = exports.default = {
  state: state,
  mutations: mutations,
  getters: getters,
  actions: actions
};